
declare var alertify: any;
declare var Notification: any;
declare var $: any;

const DuracionMensaje = (mensaje: string) => {
	// se deja de 4 segundos toda vez que se demoran mucho en desaparecer, el ingeniero fue el que dijo que 4 segundos
	// dCardenas
	const duracionOriginal = 4;
	var tiempoSugerido = mensaje.length / 10;
	if (duracionOriginal > tiempoSugerido) {
		return duracionOriginal;
	} else {
		return tiempoSugerido;
	}
}

/**
 * @author MRIOS
 */
export function MostrarMensaje(mensaje: string) {
	alertify.alert('Yéminus', mensaje);
}

/**
 * @author MRIOS
 */
export function MensajeError(mensaje: string, delay = 0) {
	if (delay == 0) {
		delay = DuracionMensaje(mensaje);
	}
	alertify.set('notifier','position', 'bottom-right');
	alertify.set('notifier', 'delay', delay);
	alertify.error(mensaje);
	alertify.set('notifier', 'delay', delay);
}

/**
 * @author MRIOS
 */
export function MensajeExito(mensaje: string, delay = 0) {
	if (delay == 0) {
		delay = DuracionMensaje(mensaje);
	}
	alertify.set('notifier','position', 'bottom-right');
	alertify.set('notifier', 'delay', delay);
	alertify.success(mensaje);
	alertify.set('notifier', 'delay', delay);
}

/**
 * @author MRIOS
 */
export function MensajeAdvertencia(mensaje: string, delay = 0) {
	if (delay == 0) {
		delay = DuracionMensaje(mensaje);
	}
	alertify.set('notifier','position', 'bottom-right');
	alertify.set('notifier', 'delay', delay);
	alertify.warning(mensaje);
	alertify.set('notifier', 'delay', delay);
}

/**
 * @author MRIOS
 */
export function MensajeNotificacion(mensaje: string, delay = 0) {
	if (delay == 0) {
		delay = DuracionMensaje(mensaje);
	}
	alertify.set('notifier','position', 'bottom-right');
	alertify.set('notifier', 'delay', delay);
	alertify.notify(mensaje);
	alertify.set('notifier', 'delay', delay);
}

/**
 * @author MRIOS
 */
export function SystemNotify(message: string) {
	try {
		if (Notification) {
			if (Notification.permission === 'granted') {
				Notification.requestPermission((status: any) => {
					if (status === 'granted') {
						let options: any = {
							body: message,
							icon: 'assets/ng1/img/logoxs.png'
						};
						let audio: HTMLAudioElement | null = new Audio('assets/sounds/new-message.mp3');
						audio.play();
						let notif = new Notification('Notificación Yéminus', options);

						// limpia variables
						options = null;
						audio = null;
						notif = null;
					}
				});
			}
		}
	} catch (error) {
		console.log(`Ocurrió un error al mostrar las notificaciones del sistema`);
	}
}

/**
 * @author MRIOS
 */
export function ConfirmarMensaje(mensaje: string, callBack: (data: boolean) => void, soloAceptar = false) {
	try {
		if (!soloAceptar) {
			alertify.confirm('Yéminus', mensaje, () => {
				callBack(true);
			},
				() => {
					callBack(false);
				});
		} else {
			alertify.alert()
				.setting({
					title: ' ',
					message: mensaje,
					onok: callBack
				}).show();
		}
	} catch (error) {
		console.log(`Ocurrió un error al Confirmar mensaje`);
	}
}

/**
 * @author MRIOS
 */
export function PromesaConfirmarMensaje(mensaje: string): Promise<boolean> {
	return new Promise((resolve, reject) => {
		try {

			alertify
				.confirm('Yéminus', mensaje,
					() => {
						resolve(true);
					},
					() => {

						reject();
					});

		} catch (error) {
			console.log(`Ocurrió un error al Confirmar mensaje`);
		}
	})
}

/**
 * @author MRIOS
 */
export function IngresarValor(mensaje: string, mensajeCancelar: string, callBack: (data: any) => {}) {
	try {
		alertify.prompt('Yéminus', mensaje, ''
			, (_evt: any, value: any) => {
				let data: any = {
					valor: value,
					ok: true
				};
				callBack(data);
				data = null;
			}
			, () => {
				if (mensajeCancelar) {
					let data: any = {
						valor: '',
						ok: false
					};
					callBack(data);
					alertify.error(mensajeCancelar);
					data = null;
				}
			});

	} catch (e) {
		console.log(`Ocurrió un error al ingresar valor`);
	}



}
